/** Display labels for various roles */
export default {
  accManager: 'Account manager',
  admin: 'Admin',
  agent: 'Agent',
  approver: 'Approver',
  filing: 'Filing',
  manager: 'Manager',
  payment: 'Payment',
  regManager: 'Registrations Manager',
  client: 'Client',
  custom: 'Custom',
} as const;

/** Enum for role codes */
export const roleCodes = {
  accManager: 'accManager',
  admin: 'admin',
  agent: 'agent',
  approver: 'approver',
  filing: 'filing',
  manager: 'manager',
  payment: 'payment',
  regManager: 'regManager',
  client: 'client',
  custom: 'custom',
} as const;
